import * as Scrivito from "scrivito";

const TableCellWidget = Scrivito.provideWidgetClass("TableCellWidget", {
  attributes: {
    cell: ["widgetlist", { only: ["IconWidget", "TextWidget"] }],
  },
  extractTextAttributes: ["cell"],
});

export default TableCellWidget;
